
















import { Component, Vue } from "@/shared/vuepack";
import { Address } from "@/shared/types";
import { useUserStore } from "@/shared/store/user";
import { useContactInfoStore } from "@/shared/store/contactinfo";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";
import { isNullEmptyOrUndefined } from "@/shared/stringHelper";

@Component({})
export default class HsbExpenseCardRowPayee extends Vue {
  userStore = useUserStore();
  contactInfoStore = useContactInfoStore();
  hsabExpenseFormStore = useHsabExpenseFormStore();

  get expense () {
    return this.hsabExpenseFormStore.expense;
  }
  get nameToDisplay () {
    if (this.expense.isPayToPayee) {
      return this.expense.payeeName;
    } else {
      return this.userStore.displayName;
    }
  }

  get accountToDisplay () {
    if (this.expense.isPayToPayee) {
      return this.expense.payeeMemberNumber;
    } else {
      return "";
    }
  }

  get addressToDisplay (): Address {
    let result: Address = {
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      zip: ""
    };
    if (this.expense.isPayToPayee) {
      result.addressLine1 = this.expense.payeeAddress1;
      result.addressLine2 = this.expense.payeeAddress2;
      result.city = this.expense.payeeCity;
      result.state = this.expense.payeeStateCode;
      result.zip = this.expense.payeeZipCode;
    } else if (this.contactInfoStore.contactInformation
        && this.contactInfoStore.contactInformation.mailingAddress) {
      result = this.contactInfoStore.contactInformation.mailingAddress;
    }

    return result;
  }

  get showSendPaymentTo () {
    return !isNullEmptyOrUndefined(this.nameToDisplay);
  }

  get showAccountNumber () {
    return !isNullEmptyOrUndefined(this.accountToDisplay);
  }

  get showAddress () {
    return !isNullEmptyOrUndefined(this.addressToDisplay);
  }
}
